<template>
  <nav 
    class="h-full bg-sidebar border-r border-sidebar flex flex-col"
    role="navigation"
    :aria-label="ariaLabel"
  >
    <!-- Sidebar Header -->
    <div class="p-4 flex-shrink-0 border-b border-border">
      <!-- Logo Row -->
      <div class="mb-3">
        <div class="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 603 182"
            style="height: 2rem; width: auto;"
          >
            <!-- Arrow/Smile paths - #0578ff in dark theme, #ff9900 in light -->
            <path
              d="m 374.00642,142.18404 c -34.99948,25.79739 -85.72909,39.56123 -129.40634,39.56123 -61.24255,0 -116.37656,-22.65135 -158.08757,-60.32496 -3.2771,-2.96252 -0.34083,-6.9999 3.59171,-4.69283 45.01431,26.19064 100.67269,41.94697 158.16623,41.94697 38.774689,0 81.4295,-8.02237 120.6499,-24.67006 5.92501,-2.51683 10.87999,3.88009 5.08607,8.17965"
              :style="{ fill: isDark ? '#0578ff' : '#ff9900' }"
            />
            <path
              d="m 388.55678,125.53635 c -4.45688,-5.71527 -29.57261,-2.70033 -40.84585,-1.36327 -3.43442,0.41947 -3.95874,-2.56925 -0.86517,-4.71905 20.00346,-14.07844 52.82696,-10.01483 56.65462,-5.2958 3.82764,4.74526 -0.99624,37.64741 -19.79373,53.35128 -2.88385,2.41195 -5.63662,1.12734 -4.35198,-2.07113 4.2209,-10.53917 13.68519,-34.16054 9.20211,-39.90203"
              :style="{ fill: isDark ? '#0578ff' : '#ff9900' }"
            />
            <!-- Text paths - white in dark theme, #221f1f in light -->
            <path
              d="M 348.49744,20.06598 V 6.38079 c 0,-2.07113 1.57301,-3.46062 3.46062,-3.46062 h 61.26875 c 1.96628,0 3.53929,1.41571 3.53929,3.46062 v 11.71893 c -0.0262,1.96626 -1.67788,4.53551 -4.61418,8.59912 l -31.74859,45.32893 c 11.79759,-0.28837 24.25059,1.46814 34.94706,7.49802 2.41195,1.36327 3.06737,3.35575 3.25089,5.32203 V 99.4506 c 0,1.99248 -2.20222,4.32576 -4.5093,3.1198 -18.84992,-9.88376 -43.887,-10.95865 -64.72939,0.10487 -2.12356,1.15354 -4.35199,-1.15354 -4.35199,-3.14602 V 85.66054 c 0,-2.22843 0.0262,-6.02989 2.25463,-9.41186 l 36.78224,-52.74829 h -32.01076 c -1.96626,0 -3.53927,-1.38948 -3.53927,-3.43441"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
            <path
              d="m 124.99883,105.45424 h -18.64017 c -1.78273,-0.13107 -3.19845,-1.46813 -3.32954,-3.17224 V 6.61676 c 0,-1.91383 1.59923,-3.43442 3.59171,-3.43442 h 17.38176 c 1.80898,0.0786 3.25089,1.46814 3.38199,3.19845 v 12.50545 h 0.34082 c 4.53551,-12.08598 13.05597,-17.7226 24.53896,-17.7226 11.66649,0 18.95477,5.63662 24.19814,17.7226 4.5093,-12.08598 14.76008,-17.7226 25.74495,-17.7226 7.81262,0 16.35931,3.22467 21.57646,10.46052 5.89879,8.04857 4.69281,19.74128 4.69281,29.99208 l -0.0262,60.37739 c 0,1.91383 -1.59923,3.46061 -3.59171,3.46061 h -18.61397 c -1.86138,-0.13107 -3.35574,-1.62543 -3.35574,-3.46061 V 51.29025 c 0,-4.03739 0.36702,-14.10466 -0.52434,-17.93233 -1.38949,-6.42311 -5.55797,-8.23209 -10.95865,-8.23209 -4.5093,0 -9.22833,3.01494 -11.14216,7.83885 -1.91383,4.8239 -1.73031,12.89867 -1.73031,18.32557 v 50.70338 c 0,1.91383 -1.59923,3.46061 -3.59171,3.46061 h -18.61395 c -1.88761,-0.13107 -3.35576,-1.62543 -3.35576,-3.46061 L 152.946,51.29025 c 0,-10.67025 1.75651,-26.37415 -11.48298,-26.37415 -13.39682,0 -12.87248,15.31063 -12.87248,26.37415 v 50.70338 c 0,1.91383 -1.59923,3.46061 -3.59171,3.46061"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
            <path
              d="m 469.51439,1.16364 c 27.65877,0 42.62858,23.75246 42.62858,53.95427 0,29.17934 -16.54284,52.32881 -42.62858,52.32881 -27.16066,0 -41.94697,-23.75246 -41.94697,-53.35127 0,-29.78234 14.96983,-52.93181 41.94697,-52.93181 m 0.15729,19.53156 c -13.73761,0 -14.60278,18.71881 -14.60278,30.38532 0,11.69271 -0.18352,36.65114 14.44549,36.65114 14.44548,0 15.12712,-20.13452 15.12712,-32.40403 0,-8.07477 -0.34082,-17.72257 -2.779,-25.3779 -2.09735,-6.65906 -6.26581,-9.25453 -12.19083,-9.25453"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
            <path
              d="M 548.00762,105.45424 H 529.4461 c -1.86141,-0.13107 -3.35577,-1.62543 -3.35577,-3.46061 l -0.0262,-95.69149 c 0.1573,-1.75653 1.7041,-3.1198 3.59171,-3.1198 h 17.27691 c 1.62543,0.0786 2.96249,1.17976 3.32954,2.67412 v 14.62899 h 0.3408 c 5.21717,-13.0822 12.53165,-19.32181 25.40412,-19.32181 8.36317,0 16.51662,3.01494 21.75999,11.27324 4.87633,7.65532 4.87633,20.5278 4.87633,29.78233 v 60.22011 c -0.20973,1.67786 -1.75653,3.01492 -3.59169,3.01492 h -18.69262 c -1.70411,-0.13107 -3.11982,-1.38948 -3.30332,-3.01492 V 50.47753 c 0,-10.46052 1.20597,-25.77117 -11.66651,-25.77117 -4.5355,0 -8.70399,3.04117 -10.77512,7.65532 -2.62167,5.84637 -2.96249,11.66651 -2.96249,18.11585 v 51.5161 c -0.0262,1.91383 -1.65166,3.46061 -3.64414,3.46061"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
            <use
              xlink:href="#path30"
              transform="translate(244.36719)"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
            <path
              id="path30"
              d="M 55.288261,59.75829 V 55.7209 c -13.475471,0 -27.711211,2.88385 -27.711211,18.77125 0,8.04857 4.16847,13.50169 11.32567,13.50169 5.24337,0 9.93618,-3.22467 12.8987,-8.46805 3.670341,-6.44935 3.486841,-12.50544 3.486841,-19.7675 m 18.79747,45.43378 c -1.23219,1.10111 -3.01495,1.17976 -4.40444,0.4457 -6.18716,-5.1385 -7.28828,-7.52423 -10.69647,-12.42678 -10.224571,10.4343 -17.460401,13.55409 -30.726141,13.55409 -15.67768,0 -27.89471,-9.67401 -27.89471,-29.04824 0,-15.12713 8.20587,-25.43035 19.87236,-30.46398 10.1197,-4.45688 24.25058,-5.24337 35.051931,-6.47556 v -2.41195 c 0,-4.43066 0.34082,-9.67403 -2.25465,-13.50167 -2.280881,-3.43442 -6.632861,-4.85013 -10.460531,-4.85013 -7.10475,0 -13.44924,3.64414 -14.99603,11.19459 -0.31461,1.67789 -1.5468,3.32955 -3.22467,3.4082 L 6.26276,32.67628 C 4.74218,32.33548 3.0643,31.10327 3.48377,28.76999 7.65225,6.85271 27.44596,0.24605 45.16856,0.24605 c 9.071011,0 20.921021,2.41195 28.078221,9.28076 9.07104,8.46804 8.20587,19.7675 8.20587,32.06321 v 29.04826 c 0,8.73022 3.61794,12.55786 7.02613,17.27691 1.20597,1.67786 1.46814,3.69656 -0.05244,4.95497 -3.80144,3.17225 -10.56538,9.07104 -14.28819,12.37436 l -0.05242,-0.0525"
              :style="{ fill: isDark ? '#FFFFFF' : '#221f1f' }"
            />
          </svg>
        </div>
      </div>
      
      <!-- Action Buttons Row -->
      <div class="flex items-center gap-2 w-full">
        <!-- Bug Report Button -->
        <BaseButton
          @click="showBugReportForm = true"
          variant="ghost"
          size="small"
          class="flex-[2] whitespace-nowrap"
        >
          <BaseIcon size="small" class="mr-2">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9997 12.75C13.1482 12.75 14.2778 12.8307 15.3833 12.9867C16.4196 13.1329 17.2493 13.9534 17.2493 15C17.2493 18.7279 14.8988 21.75 11.9993 21.75C9.09977 21.75 6.74927 18.7279 6.74927 15C6.74927 13.9535 7.57879 13.1331 8.61502 12.9868C9.72081 12.8307 10.8508 12.75 11.9997 12.75ZM11.9997 12.75C14.8825 12.75 17.6469 13.2583 20.2075 14.1901C20.083 16.2945 19.6873 18.3259 19.0549 20.25M11.9997 12.75C9.11689 12.75 6.35312 13.2583 3.79248 14.1901C3.91702 16.2945 4.31272 18.3259 4.94512 20.25M11.9997 12.75C13.2423 12.75 14.2498 11.7426 14.2498 10.5C14.2498 10.4652 14.249 10.4306 14.2475 10.3961M11.9997 12.75C10.757 12.75 9.74979 11.7426 9.74979 10.5C9.74979 10.4652 9.75058 10.4306 9.75214 10.3961M12.0002 8.25C12.995 8.25 13.971 8.16929 14.922 8.01406C15.3246 7.94835 15.6628 7.65623 15.7168 7.25196C15.7388 7.08776 15.7502 6.92021 15.7502 6.75C15.7502 6.11844 15.594 5.52335 15.3183 5.00121M12.0002 8.25C11.0053 8.25 10.0293 8.16929 9.0783 8.01406C8.67576 7.94835 8.33754 7.65623 8.28346 7.25196C8.26149 7.08777 8.25015 6.92021 8.25015 6.75C8.25015 6.1175 8.40675 5.52157 8.68327 4.99887M12.0002 8.25C10.7923 8.25 9.80641 9.20171 9.75214 10.3961M12.0002 8.25C13.208 8.25 14.1932 9.20171 14.2475 10.3961M8.68327 4.99887C8.25654 4.71496 7.86824 4.37787 7.52783 3.99707C7.59799 3.36615 7.7986 2.7746 8.10206 2.25M8.68327 4.99887C9.31221 3.81004 10.5616 3 12.0002 3C13.4397 3 14.6897 3.8111 15.3183 5.00121M15.3183 5.00121C15.7445 4.71804 16.1325 4.38184 16.4728 4.00201C16.4031 3.36924 16.2023 2.77597 15.898 2.25M4.92097 6C4.71594 7.08086 4.58339 8.18738 4.52856 9.3143C6.19671 9.86025 7.94538 10.2283 9.75214 10.3961M19.0786 6C19.2836 7.08086 19.4162 8.18738 19.471 9.3143C17.8029 9.86024 16.0542 10.2283 14.2475 10.3961" />
            </svg>
          </BaseIcon>
          Bug Report
        </BaseButton>
        
        <!-- Theme Toggle Button -->
        <BaseButton
          @click="toggleTheme"
          variant="ghost"
          size="small"
          class="flex-1 whitespace-nowrap"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
        >
          <BaseIcon size="small" class="mr-2">
            <!-- Sun icon when in dark mode (will switch to light) -->
            <svg v-if="isDark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <!-- Moon icon when in light mode (will switch to dark) -->
            <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          </BaseIcon>
          {{ isDark ? 'Light' : 'Dark' }}
        </BaseButton>
      </div>
    </div>

    <!-- Navigation Content -->
    <BaseScrollbar
      :horizontal="false"
      :vertical="true"
      :options="{
        wheelSpeed: 1,
        wheelPropagation: false,
        swipeEasing: true,
        suppressScrollX: true,
        suppressScrollY: false
      }"
      class="flex-1"
    >
      <div class="p-4 space-y-2">
        <!-- Jobs Section -->
        <div class="mt-2">
          <BaseDisclosureItem to="/amazon/products" :active="isActiveRoute('/amazon/products')">
            <template #icon>
              <BaseIcon size="small" variant="ghost">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </BaseIcon>
            </template>
            <template #content>
              <span>Search Portal</span>
            </template>
          </BaseDisclosureItem>
        </div>
      </div>
    </BaseScrollbar>

    <!-- Bug Report Form Modal -->
    <BugReportForm
      v-model="showBugReportForm"
      @submitted="handleBugReportSubmitted"
    />

    <!-- Sidebar Footer -->
    <div class="p-4 border-t border-border flex-shrink-0 sidebar-footer">
      <BaseMenu
        :model-value="userMenuOpen"
        @update:model-value="userMenuOpen = $event"
        position="top"
        :items="userMenuItems"
        full-width
        @item-click="handleUserMenuClick"
      >
        <template #trigger>
          <div 
            class="user-profile-button"
            :class="{ 'user-profile-button--collapsed': collapsed }"
            role="button"
            tabindex="0"
            :aria-expanded="userMenuOpen"
            aria-haspopup="true"
            @click.stop="userMenuOpen = !userMenuOpen"
            @keydown.enter="userMenuOpen = !userMenuOpen"
            @keydown.space.prevent="userMenuOpen = !userMenuOpen"
          >
            <BaseCircularBadge
              text="Demo User"
              size="medium"
              variant="blue"
              :show-text="false"
            />
            <div v-if="!collapsed" class="user-info">
              <div class="user-name">
                <BaseText size="small" class="font-medium">Demo User</BaseText>
              </div>
              <div class="user-email">
                <BaseText size="xsmall" class="text-text-muted">demo@amazon.com</BaseText>
              </div>
            </div>
            <div v-if="!collapsed" class="user-chevron">
              <BaseIcon size="small" variant="ghost">
                <ChevronDownIcon />
              </BaseIcon>
            </div>
          </div>
        </template>
      </BaseMenu>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAmazonTheme } from '@/composables/useAmazonTheme'
import { useToast } from 'vue-toastification'
import BaseDisclosureItem from '@/components/ui/BaseDisclosureItem.vue'
import BaseIcon from '@/components/ui/BaseIcon.vue'
import BaseText from '@/components/ui/BaseText.vue'
import BaseCircularBadge from '@/components/ui/BaseCircularBadge.vue'
import BaseButton from '@/components/navigation/BaseButton.vue'
import BaseMenu from '@/components/navigation/BaseMenu.vue'
import BugReportForm from '@/components/bug-reports/BugReportForm.vue'
import BaseScrollbar from '@/components/layout/BaseScrollbar.vue'
import ChevronDownIcon from '@/components/icons/ChevronDownIcon.vue'

interface Props {
  collapsed?: boolean
  ariaLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  collapsed: false,
  ariaLabel: 'Amazon navigation'
})

const route = useRoute()
const toast = useToast()
const { isDark, toggleTheme } = useAmazonTheme()

const userMenuOpen = ref(false)
const showBugReportForm = ref(false)

const userMenuItems = [
  {
    label: 'Settings',
    href: '/settings',
    icon: 'settings'
  },
  {
    label: 'Logout',
    action: 'logout',
    icon: 'logout'
  }
]

const isActiveRoute = (routePath: string): boolean => {
  return route.path === routePath || route.path.startsWith(routePath + '/')
}

const handleUserMenuClick = async (item: any) => {
  if (item.action === 'logout') {
    // Static demo - just show a message
  } else if (item.href) {
    // Navigate to the href
    window.location.href = item.href
  }
}

const handleBugReportSubmitted = () => {
  showBugReportForm.value = false
  toast.success('Bug report submitted successfully (static demo)')
}
</script>

<style scoped>
.user-profile-button {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.5rem;
  background-color: transparent;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  text-align: left;
}

.user-profile-button:hover {
  background-color: var(--color-surface-hover);
}

.user-profile-button--collapsed {
  justify-content: center;
  padding: 0.5rem;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name,
.user-email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-chevron {
  flex-shrink: 0;
}

.user-profile-button[aria-expanded="true"] .user-chevron {
  transform: rotate(180deg);
}

.sidebar-footer {
  background-color: var(--color-sidebar-footer-bg);
}
</style>

